export enum DeviceEnum {
  MOBILE = 'MOBILE',
  BROWSER = 'BROWSER'
}
